import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'ramda'
import withStyle from './Badge.style.js'

const Badge = ({ text, type, className, dataTestId }) => (
  <span className={className} data-testid={dataTestId}>
    {text}
  </span>
)

Badge.defaultProps = {
  type: 'default',
}

Badge.propTypes = {
  className: PropTypes.string,
  /** Short text to show within the Badge */
  text: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  type: PropTypes.oneOf([
    'default',
    'true',
    'false',
    'alert',
    'selected',
    'warning',
  ]),
  dataTestId: PropTypes.string,
}

export default compose(withStyle, memo)(Badge)
